/**
 * Stock & shipping bar - real visitor country detection.
 *
 * Liquid renders `localization.country`, which is the active Shopify Market
 * country, not where the visitor actually is. A visitor in a country with no
 * Market falls back to the default Market (e.g. GB). This upgrades the
 * rendered country to the one Shopify detects from the visitor's IP.
 */
(function () {
  if (window.__stockShippingBarInit) return;
  window.__stockShippingBarInit = true;

  var ENDPOINT = '/browsing_context_suggestions.json';
  var CACHE_KEY = 'ssb:detected-country';

  function apply(country) {
    if (!country || !country.handle) return;

    var bars = document.querySelectorAll('.stock-shipping-bar[data-ssb-geolocate="true"]');

    for (var i = 0; i < bars.length; i++) {
      var bar = bars[i];
      var label = bar.querySelector('.stock-shipping-bar__country');

      if (label) {
        label.textContent = bar.getAttribute('data-ssb-display') === 'name'
          ? country.name || country.handle
          : country.handle;
      }

      var flag = bar.querySelector('.country-flags');

      if (flag) {
        flag.className = flag.className.replace(/country-flags--[A-Za-z_]+/, 'country-flags--' + country.handle);
      }

      bar.setAttribute('data-ssb-resolved', country.handle);
    }
  }

  function readCache() {
    try {
      return JSON.parse(sessionStorage.getItem(CACHE_KEY));
    } catch (e) {
      return null;
    }
  }

  var cached = readCache();

  if (cached) {
    apply(cached);
    return;
  }

  fetch(ENDPOINT, { headers: { Accept: 'application/json' } })
    .then(function (response) {
      return response.ok ? response.json() : null;
    })
    .then(function (data) {
      var country = data && data.detected_values && data.detected_values.country;

      if (!country || !country.handle) return;

      try {
        sessionStorage.setItem(CACHE_KEY, JSON.stringify(country));
      } catch (e) {}

      apply(country);
    })
    .catch(function () {});
})();
